import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  loginForm = new UntypedFormGroup({
    email: new UntypedFormControl(''),
    password: new UntypedFormControl('')
  });
  
  errorMessage: string = '';
  isLoading: boolean = false;

  constructor(
    private _authService: AuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
  }

  onLoginGoogle() {
    this.isLoading = true;
    this.errorMessage = '';
    
    this._authService.authGoogleAuth()
      .then(() => {
        this.isLoading = false;
        this.router.navigate(['/home']);
      })
      .catch((error) => {
        this.isLoading = false;
        this.errorMessage = this.getErrorMessage(error.code);
        console.error('Error en login con Google:', error);
      });
  }

  private getErrorMessage(errorCode: string): string {
    switch (errorCode) {
      case 'auth/popup-closed-by-user':
        return 'Cerraste la ventana de inicio de sesión. Inténtalo de nuevo.';
      case 'auth/cancelled-popup-request':
        return 'Ya hay una ventana de inicio de sesión abierta.';
      case 'auth/popup-blocked':
        return 'El navegador bloqueó la ventana emergente. Por favor, permite las ventanas emergentes para este sitio.';
      case 'auth/network-request-failed':
        return 'No hay conexión a internet. Verifica tu conexión e inténtalo de nuevo.';
      case 'auth/user-disabled':
        return 'Tu cuenta ha sido deshabilitada. Contacta al soporte.';
      case 'auth/operation-not-allowed':
        return 'El inicio de sesión con Google no está habilitado. Contacta al administrador.';
      case 'auth/unauthorized-domain':
        return 'Este dominio no está autorizado para iniciar sesión. Contacta al administrador.';
      case 'auth/account-exists-with-different-credential':
        return 'Ya existe una cuenta con este correo usando otro método de inicio de sesión.';
      default:
        return 'Ocurrió un error al iniciar sesión. Inténtalo de nuevo.';
    }
  }
}
